import React, { useEffect } from "react";
import SearchBar from "../../../components/searchBar";
import { useDashboardContext } from "../../../context/dashboardContext";
import { PayoutResponseDTO } from "../../../openapi-generated-client";
import PayOutInfoTable from "../../../pageparts/payoutInfoTable";

export default function DashboardPayoutRequestsPage() {

    const {sessionId, appContext} = useDashboardContext();
    const {payoutController} = appContext;

    const [search, setSearch] = React.useState("");

    const [openRequests, setOpenRequests] = React.useState<PayoutResponseDTO[]>([]);
    const [closedRequests, setClosedRequests] = React.useState<PayoutResponseDTO[]>([]);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        payoutController.getPayoutRequest(sessionId).then((response) => {
            setOpenRequests(response.data.open);
            setClosedRequests(response.data.closed);
        });
    }

    function filterRequestList(requests: PayoutResponseDTO[]): PayoutResponseDTO[] {
        return requests.filter(request =>
                request.artist.toLowerCase().includes(search.toLowerCase()) ||
                request.artistId.toString().toLowerCase().includes(search.toLowerCase()) ||
                request.iban.toLowerCase().includes(search.toLowerCase()) ||
                request.bic.toLowerCase().includes(search.toLowerCase()) ||
                request.recipient.toLowerCase().includes(search.toLowerCase()) ||
                request.id.toString().toLowerCase().includes(search.toLowerCase())
            );
    }

    return <div className="page">
            <SearchBar search={search} onSearch={setSearch}/>
            <PayOutInfoTable refetch={fetchData} openRequests={filterRequestList(openRequests)} closedRequests={filterRequestList(closedRequests)} />
        </div>;
}